import React, { Component } from 'react';
import { Modal, Radio, Input, Spin, message } from 'antd';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import Text from '../../../basicElement/Text';

const { Group: RadioGroup } = Radio;
const CONSTANTS = {
    apply: {
        apply: true,
        title: '申请调整客户付款单位',
        endPoint: API_URL.contract.createContractRemittanceCustomerApply,
    },
    approve: {
        approve: true,
        title: '审批客户付款单位调整申请',
        endPoint: API_URL.contract.handleContractRemittanceCustomerApply,
    },
    REJECT: true,
};

class AdjustPayUnit extends Component {
    state = {
        data: {},
        record: {},
        type: 'apply',
        visible: false,
        loading: false,
    }

    loadData = () => {
        const { record: { contractRemittanceApplicationId } } = this.state;
        Fetch.post(API_URL.contract.queryContractRemittanceCustomerApplyById, {contractRemittanceApplicationId})
        .then(res => {
            const { data } = res;
            const { contractRemittanceCustomerApplyId, newCustomerCompany, reason } = data;
            const { record } = this.state;
            record.contractRemittanceCustomerApplyId = contractRemittanceCustomerApplyId;
            record.customerCompanyName = newCustomerCompany;
            record.reason = reason;
            this.setState({
                record,
                loading: false,
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    show = (record, type) => {
        this.setState({
            type,
            record,
            data: {},
            visible: true,
        }, () => {
            CONSTANTS[type]['approve'] && this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = ({value, text}) => {
        const { data } = this.state;
        data.customerCompanyId = value;
        data.customerCompanyName = text;
        this.setState({ data });
    }

    handleInputChange = (e, key) => {
        const { data } = this.state;
        data[key] = e.target.value;
        if (key === 'applyStatus') {
            data.rejectReason = '';
        }
        this.setState({ data });
    }

    submit = () => {
        const { type, data, record } = this.state;
        const { contractRemittanceApplicationId, contractRemittanceCustomerApplyId } = record;
        const { customerCompanyId, reason, applyStatus, rejectReason } = data;
        if (CONSTANTS[type]['apply']) {
            if (!customerCompanyId) {
                message.warning('请选择申请调整后的客户！');
                return;
            } else if (!reason) {
                message.warning('请输入调整原因！');
                return;
            }
            data.contractRemittanceApplicationId = contractRemittanceApplicationId;
        } else {
            if (!applyStatus) {
                message.warning('请选择审批结论！');
                return;
            } else if (CONSTANTS[applyStatus] && !rejectReason) {
                message.warning('请输入拒绝原因！');
                return;
            }
            data.contractRemittanceCustomerApplyId = contractRemittanceCustomerApplyId;
        }

        this.setState({ loading: true });
        Fetch.post(CONSTANTS[type].endPoint, data)
        .then(res => {
            message.success(res.success);
            this.hide();
            this.setState({
                loading: false,
            }, () => {
                this.props.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    getContent = () => {
        const { record, data, type } = this.state;
        const {
            investigationJdeContractCode,
            customerCompany,
            remittanceCode,
            remittanceNum,
            customerCompanyName: record_customerCompanyName,
            reason: record_reason,
        } = record;
        const { customerCompanyName, reason, applyStatus, rejectReason } = data;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">JDE项目号:</div>
                    <div className="item-right">{investigationJdeContractCode}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">客户付款单位:</div>
                    <div className="item-right">{customerCompany}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">请款单号:</div>
                    <div className="item-right">{remittanceCode}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">请款笔数:</div>
                    <div className="item-right">{remittanceNum}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={CONSTANTS[type]['apply']} colon={true}>申请调整为</Text></div>
                    <div className="item-right">
                        {
                            CONSTANTS[type]['apply'] ?
                                <SearchRetrieve
                                    keyword='customerCompanyName'
                                    style={{ width: 240 }}
                                    placeholder="输入客户名称或代码检索"
                                    value={customerCompanyName}
                                    params={{ limit: 20 }}
                                    url={API_URL.investigation.queryCustomerCompanyByName}
                                    config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                    onChange={this.handleChange}
                                />
                            :
                                customerCompanyName || record_customerCompanyName
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={CONSTANTS[type]['apply']} colon={true}>调整原因</Text></div>
                    <div className="item-right">
                        {
                            CONSTANTS[type]['apply'] ?
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 240 }}
                                    value={reason}
                                    onChange={e => this.handleInputChange(e, 'reason')}
                                />
                            :
                                reason || record_reason
                        }
                    </div>
                </li>
                {
                    CONSTANTS[type]['approve'] &&
                    <li className="modal-item" style={{ borderTop: '1px solid #f1f1f1' }}>
                        <div className="item-left"><Text asterisk={true} colon={true}>审批结论</Text></div>
                        <div className="item-right">
                            <RadioGroup onChange={e => this.handleInputChange(e, 'applyStatus')} value={applyStatus}>
                                <Radio value='AGREE'>同意</Radio>
                                <Radio value='REJECT'>拒绝</Radio>
                            </RadioGroup>
                        </div>
                    </li>
                }
                {
                    CONSTANTS[type]['approve'] && CONSTANTS[applyStatus] &&
                    <li className="modal-item">
                        <div className="item-left">&nbsp;</div>
                        <div className="item-right">
                            <Input
                                maxLength="255"
                                value={rejectReason}
                                placeholder="请填写拒绝原因"
                                style={{width: 240}}
                                onChange={e => this.handleInputChange(e, 'rejectReason')}
                            />
                        </div>
                    </li>
                }
            </ul>
        );
    }

    render() {
        const { visible, loading, type } = this.state;
        return (
            <Modal
                title={CONSTANTS[type].title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                confirmLoading={loading}
                maskClosable={false}
                width="520px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: 0 }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default AdjustPayUnit;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/AdjustPayUnit.js